var _circle, _circle2, _circle3, _circle4, _line, _line2, _line3, _line4, _g, _text, _text2, _text3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAppLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 350,
    height: 80,
    viewBox: "0 0 350 80",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 30,
    cy: 25,
    r: 8,
    fill: "#1A8089"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 60,
    cy: 40,
    r: 6,
    fill: "#44DFED"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 30,
    cy: 55,
    r: 6,
    fill: "#2EC5D2"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 65,
    cy: 15,
    r: 5,
    fill: "#35831F"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 30,
    y1: 25,
    x2: 60,
    y2: 40,
    stroke: "#44DFED",
    strokeWidth: 2,
    opacity: 0.6
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 30,
    y1: 25,
    x2: 30,
    y2: 55,
    stroke: "#2EC5D2",
    strokeWidth: 2,
    opacity: 0.6
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 30,
    y1: 25,
    x2: 65,
    y2: 15,
    stroke: "#35831F",
    strokeWidth: 2,
    opacity: 0.6
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 60,
    y1: 40,
    x2: 30,
    y2: 55,
    stroke: "#1A8089",
    strokeWidth: 2,
    opacity: 0.4
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(26, 21)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 2 2 Q 4 0 6 2 Q 4 6 4 6 Q 2 6 2 2",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 4,
    cy: 2,
    r: 1,
    fill: "white"
  }))), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 85,
    y: 30,
    fontFamily: "Segoe UI, sans-serif",
    fontSize: 20,
    fontWeight: 700,
    fill: "#1A8089"
  }, "ONLINE")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 85,
    y: 50,
    fontFamily: "Segoe UI, sans-serif",
    fontSize: 20,
    fontWeight: 700,
    fill: "#2EC5D2"
  }, "APPLICATIONS")), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    x: 85,
    y: 65,
    fontFamily: "Segoe UI, sans-serif",
    fontSize: 10,
    fontWeight: 400,
    fill: "#8791AB"
  }, "Digital Service Network")));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppLogo);
export default __webpack_public_path__ + "static/media/app-logo.c1681ecda2db66426b94303b2cfb23c5.svg";
export { ForwardRef as ReactComponent };